import {
	ArrowDownOutlined,
	ArrowUpOutlined,
	BankOutlined,
	FileTextOutlined,
	ShoppingCartOutlined,
	WalletOutlined,
} from "@ant-design/icons";
import type { ReactNode } from "react";
import type { DashboardKpi, DashboardKpiIcon } from "../types/dashboard.types";

const kpiIcons: Record<DashboardKpiIcon, ReactNode> = {
	sales: <ShoppingCartOutlined />,
	revenue: <BankOutlined />,
	activeSales: <FileTextOutlined />,
	payments: <WalletOutlined />,
};

interface KpiCardProps {
	kpi: DashboardKpi;
	onClick?: () => void;
}

export function KpiCard({ kpi, onClick }: KpiCardProps) {
	const hasTrend = Boolean(kpi.trend);
	const TrendIcon = kpi.trend === "down" ? ArrowDownOutlined : ArrowUpOutlined;

	return (
		<div className={`crm-kpi ${onClick ? "clickable" : ""}`} onClick={onClick}>
			<div className="crm-kpi-title">
				<span className={`crm-kpi-icon ${kpi.tone}`}>{kpiIcons[kpi.icon]}</span>
				{kpi.title}
			</div>
			<div className="crm-kpi-value">
				<strong>{kpi.value}</strong>
				{kpi.unit ? <span>{kpi.unit}</span> : null}
			</div>
			<div className={hasTrend ? "crm-kpi-delta" : "crm-kpi-note"}>
				{hasTrend ? <TrendIcon /> : null}
				{kpi.note}
			</div>
		</div>
	);
}
